@if (isLoading) {
<cui-spinner></cui-spinner>
}
<div
  class="
    flex
    justify-between
    items-center
    section-heading-container
    left-rail-section-header
  "
>
  <cla-left-rail-section-heading> Loss Details </cla-left-rail-section-heading>
</div>
<div class="p-xxs loss-details-container" data-pgr-id="tleLossDetails">
  <div id="factsOfLossLabel" class="text-sm loss-details-label mb-bl-2">
    Facts of Loss
  </div>
  <p
    role="status"
    aria-labelledby="factsOfLossLabel"
    class="text-sm mb-bl-2 break-words"
  >
    @if (isInitialLoad) {
    <span class="ghost-line w-3/4"></span>
    } @if (!isInitialLoad) {
    <span>
      {{ claimDetails?.factsOfLoss1 }}
      @if (claimDetails?.factsOfLoss2) {
      <span class="block mt-bl-1">
        {{ claimDetails?.factsOfLoss2 }}
      </span>
      } @if ( !isInitialLoad && !claimDetails?.factsOfLoss1 &&
      !claimDetails?.factsOfLoss2 ) { - }
    </span>
    }
  </p>
  <cui-data-list density="condensed" [border]="false">
    <cui-data-list-row labelSpan="8rem">
      <span list-item-label class="loss-details-label"> Claim Status </span>
      <div class="smallerChip">
        <cla-claim-status-indicator
          [claimDetails]="claimDetails"
          [isInitialLoad]="isInitialLoad"
        ></cla-claim-status-indicator>
      </div>
    </cui-data-list-row>
    <cui-data-list-row labelSpan="8rem">
      <span list-item-label class="loss-details-label">
        {{ claimDetails?.companyName == "LYFT" ? "Lyft ID" : "Reference #" }}
      </span>
      @if (isInitialLoad) {
      <span class="ghost-line w-2/3"></span>
      } @if (!isInitialLoad) { @if ( claimDetails?.companyName == 'UBER' ||
      claimDetails?.companyName == 'LYFT' ) {
      {{
        (claimDetails?.referenceNumber != null
          ? claimDetails?.referenceNumber
          : "-"
        ) | claEmptyDash
      }}
      } }
    </cui-data-list-row>
    @if ( claimDetails?.dualLossClaimCentury && claimDetails?.dualLossClaimYear
    && claimDetails?.dualLossClaimNumber ) {
    <cui-data-list-row labelSpan="8rem">
      <span list-item-label class="loss-details-label"> Dual Loss </span>
      @if (isInitialLoad) {
      <span class="ghost-line"></span>
      } @if (!isInitialLoad) {
      <cui-copy-button
        [ariaLabel]="
          'copy claim number ' +
          claimDetails?.dualLossClaimYear +
          '-' +
          claimDetails?.dualLossClaimNumber
        "
        [dataToCopy]="
          claimDetails?.dualLossClaimYear +
          '-' +
          claimDetails?.dualLossClaimNumber
        "
      >
        <span>
          {{ claimDetails?.dualLossClaimYear }}-{{
            claimDetails?.dualLossClaimNumber
          }}
        </span>
      </cui-copy-button>
      }
    </cui-data-list-row>
    }
    <cui-data-list-row labelSpan="8rem">
      <span list-item-label class="loss-details-label"> Loss State </span>
      @if (isInitialLoad) {
      <span class="ghost-line"></span>
      } @if (!isInitialLoad) {
      {{ claimDetails?.accidentLocationState.name | claEmptyDash }}
      }
    </cui-data-list-row>
    <cui-data-list-row labelSpan="8rem">
      <span list-item-label class="loss-details-label"> Policy State </span>
      @if (isInitialLoad) {
      <span class="ghost-line w-2/3"></span>
      } @if (!isInitialLoad) { @if (claimDetails?.policyNumber) {
      {{ claimDetails?.policyState?.name | claEmptyDash }}
      @if (isMassachusettsPolicyState) {
      <cla-surcharge-indicator
        [surchargeCode]="claimDetails?.surchargeCode"
      ></cla-surcharge-indicator>
      } } @if (!claimDetails?.policyNumber) { — } }
    </cui-data-list-row>
  </cui-data-list>
  <div [@additionalDetailsExpansion]="expanded ? 'expanded' : 'collapsed'">
    <cui-data-list density="condensed" [border]="false">
      <cui-data-list-row labelSpan="8rem">
        <span list-item-label class="loss-details-label"> Loss Date </span>
        @if (isInitialLoad) {
        <span class="ghost-line"></span>
        } @if (!isInitialLoad) { @if (claimDetails?.claimLossDate) {
        {{ claimDetails?.claimLossDate | date: "MM/dd/yyyy, hh:mm a" }}
        {{ claimDetails?.claimLossTimeZone }}
        } @if (!claimDetails?.claimLossDate) { — } }
      </cui-data-list-row>
      <cui-data-list-row labelSpan="8rem">
        <span list-item-label class="loss-details-label"> Reported on </span>
        @if (isInitialLoad) {
        <span class="ghost-line w-1/2"></span>
        } @if (!isInitialLoad) { @if (claimDetails?.claimReportDate) {
        {{ claimDetails?.claimReportDate | date: "MM/dd/yyyy, hh:mm a" }}
        {{ claimDetails?.claimReportTimeZone }}
        } @if (!claimDetails?.claimReportDate) { - } }
      </cui-data-list-row>
      <cui-data-list-row labelSpan="8rem">
        <span list-item-label class="loss-details-label"> Reported by </span>
        @if (isInitialLoad) {
        <span class="ghost-line w-2/3"></span>
        } @if (!isInitialLoad) {
        {{ claimDetails?.claimReportedBy?.description | claEmptyDash }}
        }
      </cui-data-list-row>
      <cui-data-list-row labelSpan="8rem">
        <span list-item-label class="loss-details-label"> Reported via </span>
        @if (isInitialLoad) {
        <span class="ghost-line w-2/3"></span>
        } @if (!isInitialLoad) {
        {{ claimDetails?.claimReportedVia | claEmptyDash }}
        }
      </cui-data-list-row>
    </cui-data-list>
    <mat-divider class="my-xxs"></mat-divider>
    <div id="lossLocationLabel" class="text-sm loss-details-label mb-bl-2">
      Loss Location
    </div>
    <p aria-labelledby="lossLocationLabel">
      @if (isInitialLoad) {
      <span class="ghost-line w-3/4"></span>
      } @if (!isInitialLoad) {
      <span>
        <cla-google-maps-address
          [address]="
            claimDetails?.lossLocationDisplayLine1 +
            ' ' +
            claimDetails?.lossLocationDisplayLine2 +
            ' ' +
            claimDetails?.lossLocationDisplayLine3 +
            ' ' +
            claimDetails?.lossLocationDisplayLine4
          "
        ></cla-google-maps-address>
      </span>
      } @if ( !isInitialLoad && !claimDetails?.accidentLocation &&
      !claimDetails?.accidentLocationCityName &&
      !claimDetails?.accidentLocationState ) { - }
    </p>
  </div>
</div>
<button class="expand-toggle" (click)="toggleExpanded()">
  <span>{{ expanded ? "Less" : "More" }}</span>
  <mat-icon>{{ expanded ? "expand_less" : "expand_more" }}</mat-icon>
</button>
